//import axios from "axios";

//const API_URL = 'http://localhost:2011/api/definition';

//const API_URL = "http://localhost:2011/api/definition";

//http://localhost:2011

// http://localhost:2011

import api from "./api";

const APIDefinitionService = {
  createApiDefinition(apiDefinition) {
    return api.post("/api/definition/save", apiDefinition);
  },

  getAllApiDefinitions() {
    return api.get("/api/definition/view");
  },

  getApisByProject(projectId) {
    return api.get(`/api/definition/project/${projectId}`);
  },

  getApiById(id) {
    return api.get(`/api/definition/${id}`);
  },

  updateApiDefinition(id, apiDefinition) {
    return api.put(`/api/definition/update/${id}`, apiDefinition);
  },

  deleteApiDefinition(id) {
    return api.delete(`/api/definition/delete/${id}`);
  },
};

export default APIDefinitionService;
